document.addEventListener("DOMContentLoaded", function () {
  // Elements
  const optionCards = document.querySelectorAll(".option-card");
  const serviceCards = document.querySelectorAll(".service-card");
  const continueBtn = document.getElementById("continue-btn");
  const mobContBtn = document.getElementById("continue-btn-mbl");
  const selectedRepairsList = document.getElementById("selected-repairs-list");
  const selectedRepairMethod = document.getElementById(
    "selected-service-option"
  );
  const visitSteps = document.querySelectorAll(".visit-step");
  const vanSteps = document.querySelectorAll(".vanSteps.vab");
  const methodSummary = document.getElementById("method-summary");
  const changeRepairBtn = document.querySelector(".change-repair-btn");
  // const serviceCards = document.querySelector(".service-card");
  const backBtn = document.querySelector(".back-button");

  // Step navigation
  const steps = document.querySelectorAll(".step");
  const stepContents = document.querySelectorAll(".step-content");

  let currentStep = 1;
  let selectedRepairs = {}; // Object to store selected repairs by repair type ID
  let selectedMethod = null;
  // Visit Us functionality
  const visitUsContent = document.getElementById("visit-us-content");
  const mailInContent = document.getElementById("mail-in-content");
  const bookVanContent = document.getElementById("book-van-content");
  const storeItems = document.querySelectorAll(".store-item");
  const vanContBtn = document.querySelector(".van-continue-btn");
  const vanInfoCard = document.querySelector(".van-info-card");
  const vanBookingSteps = document.querySelector(".vanSteps");
  const vanBookingStepsContent = document.querySelectorAll(
    ".vanSteps .visit-step"
  );
  const mobSummaryToggle = document.querySelector(
    ".mobile-summary-section .summary-section"
  );
  const mobDetCloseBtn = document.querySelector(
    ".mobile-summary-section .summar-details-close-btn"
  );
  const summaryDetailsMbl = document.querySelector(
    ".mobile-summary-section .summary-details-mbl"
  );
  mobDetCloseBtn.addEventListener("click", function () {
    if (summaryDetailsMbl) {
      summaryDetailsMbl.classList.remove("show-mbl-sumdet");
      document.querySelector(
        ".mobile-summary-section .summary-section"
      ).style.display = "flex";
      document.querySelector(
        ".mobile-summary-section .summar-details-close-btn"
      ).style.display = "none";
    }
  });
  mobSummaryToggle.addEventListener("click", function () {
    console.log(summaryDetailsMbl);
    if (summaryDetailsMbl) {
      summaryDetailsMbl.classList.add("show-mbl-sumdet");
      document.querySelector(
        ".mobile-summary-section .summary-section"
      ).style.display = "none";
      document.querySelector(
        ".mobile-summary-section .summar-details-close-btn"
      ).style.display = "flex";
    }
  });
  vanContBtn.addEventListener("click", function () {
    const serviceTitle = document.querySelector("#service-option-title");
    if (serviceTitle) {
      serviceTitle.scrollIntoView({ behavior: "smooth", block: "start" ,offsetTop: 20});
    }
    vanInfoCard.classList.remove("van-info-card-active");
    vanBookingSteps.style.display = "block";
    vanBookingStepsContent[0].classList.add("active");
  });
  let selectedStore = null;

  // Initialize
  updateUI();

  // Event Listers
  optionCards.forEach((card) => {
    // Skip cards that are disabled (by attribute or by class)
    if (card.hasAttribute("disabled") || card.classList.contains("disabled")) {
      return;
    }
    card.addEventListener("click", function () {
      const repairTypeId = this.getAttribute("data-repair-type-id");

      // Remove selected class from all cards of the same repair type
      document
        .querySelectorAll(`.option-card[data-repair-type-id="${repairTypeId}"]`)
        .forEach((c) => {
          c.classList.remove("selected");
        });

      // Add selected class to clicked card
      this.classList.add("selected");

      // Store selected repair
      selectedRepairs[repairTypeId] = {
        variantId: this.getAttribute("data-variant-id"),
        type: this.getAttribute("data-repair-type"),
        price: this.getAttribute("data-price"),
        repairTime: this.getAttribute("data-repair-time"),
        warranty: this.getAttribute("data-warranty"),
        typeName: this.getAttribute("data-repair-type-name"),
      };
      // Store globally
      window.shopSettings.selectedRepairs = selectedRepairs;

      // Update UI
      updateUI();
    });
  });

  //   serviceCards.forEach((card) => {
  //     card.addEventListener("click", function () {
  //       // Remove selected class from all cards
  //       serviceCards.forEach((c) => c.classList.remove("selected"));

  //       // Add selected class to clicked card
  //       this.classList.add("selected");

  //       // Store selected method
  //       selectedMethod = this.getAttribute("data-service-method");

  //       // Update UI
  //       updateUI();
  //     });
  //   });
  // Show Visit Us content when Visit Us service is selected
  // Service card selection
  serviceCards.forEach((card) => {
    card.addEventListener("click", function () {
      const method = this.getAttribute("data-service-method");
      const serviceTitle = document.querySelector("#service-option-title");
      if (serviceTitle) {
        serviceTitle.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      // If this card is already selected, do nothing
      if (this.classList.contains("selected")) {
        goToStep(2); // Go back to step 1

        // Deselect and reset based on the selected method
        if (method === "Visit Us") {
          serviceCards.forEach((c) => c.classList.remove("selected"));
          selectedMethod = null;
          // Hide all method content
          document
            .querySelectorAll(".service-method-content")
            .forEach((content) => {
              content.style.display = "none";
            });
          serviceCards.forEach((card) => (card.style.display = "flex"));
          visitSteps.forEach((step) => {
            step.classList.remove("active");
          });
          // visitSteps[0].classList.add("active");
        } else if (method === "Mail In") {
          serviceCards.forEach((c) => c.classList.remove("selected"));
          selectedMethod = null;
          document
            .querySelectorAll(".service-method-content")
            .forEach((content) => {
              content.style.display = "none";
            });
          serviceCards.forEach((card) => (card.style.display = "flex"));
          // Reset any Mail In specific UI here if needed
        } else if (method === "Book a Van") {
          serviceCards.forEach((c) => c.classList.remove("selected"));
          selectedMethod = null;
          document
            .querySelectorAll(".service-method-content")
            .forEach((content) => {
              content.style.display = "none";
            });
          serviceCards.forEach((card) => (card.style.display = "flex"));
          vanBookingSteps.style.display = "none";
          console.log(vanBookingStepsContent);
          vanBookingStepsContent.forEach((step) =>
            step.classList.remove("active")
          );
          // Reset any Book a Van specific UI here if needed
        } else {
          serviceCards.forEach((c) => c.classList.remove("selected"));
          selectedMethod = null;
          document
            .querySelectorAll(".service-method-content")
            .forEach((content) => {
              content.style.display = "none";
            });
          serviceCards.forEach((card) => (card.style.display = "flex"));
        }
      } else {
        // currentStep = 3; // Set to step 2 when a service method is selected
        goToStep(3); // Go to step 2
        // Remove selected class from all cards
        serviceCards.forEach((c) => c.classList.remove("selected"));

        // Add selected class to clicked card
        this.classList.add("selected");

        // Store selected method
        selectedMethod = method;
        console.log(selectedMethod, "selectedMethod");
        window.shopSettings.selectedMethod = selectedMethod; // Store globally

        // Hide all method content first
        document
          .querySelectorAll(".service-method-content")
          .forEach((content) => {
            content.style.display = "none";
          });

        // Show the appropriate content based on selection
        if (method === "Visit Us") {
          serviceCards[1].style.display = "none";
          serviceCards[2].style.display = "none";
          visitUsContent.style.display = "block";

          // Update the sidebar
          methodSummary.style.display = "block";
          selectedRepairMethod.innerHTML = `Visit Mobile Arcade repair shop`;
          visitSteps[0].classList.add("active");
        } else if (method === "Mail In") {
          selectedMethod;
          serviceCards[0].style.display = "none";
          serviceCards[2].style.display = "none";
          mailInContent.style.display = "block";

          // Update the sidebar
          methodSummary.style.display = "block";
          selectedRepairMethod.innerHTML = `Mail In to Mobile Arcade repair shop`;
          continueBtn.classList.add("active");
          continueBtn.disabled = false;
        } else if (method === "Book a Van") {
          serviceCards[0].style.display = "none";
          serviceCards[1].style.display = "none";
          bookVanContent.style.display = "block";
          vanInfoCard.classList.add("van-info-card-active");

          // Update the sidebar
          methodSummary.style.display = "block";
          selectedRepairMethod.innerHTML = `Book a van`;
        } else {
          // For other methods, just show the method name
          methodSummary.style.display = "block";
          selectedRepairMethod.textContent = method;
        }
      }
      // Update UI
      updateUI();
    });
  });
  //   Add Close all others on different open
  visitSteps.forEach((visitStp) => {
    const VisitUsHead = visitStp.querySelector(".accordianVisitUsHead");
    VisitUsHead.addEventListener("click", function () {
      // Remove 'active' from all steps
      visitSteps.forEach((step) => step.classList.remove("active"));
      // Add 'active' to the clicked step
      visitStp.classList.add("active");
      console.log(VisitUsHead);

      // console.log(`Activated step index: ${index}`);
    });
  });
  // Store selection
  storeItems.forEach((store) => {
    store.addEventListener("click", function () {
      // Remove selected class from all stores
      storeItems.forEach((s) => s.classList.remove("selected"));
      visitSteps.forEach((step) => {
        step.classList.remove("active");
      });
      console.log(visitSteps[1], "visitSteps[1]");
      // Add 'active' to Step 2 (index 1)
      visitSteps[1].classList.add("active");
      //   }
      // Add selected class to clicked store
      this.classList.add("selected");
      //   console.log(this);
      // Store selected store data
      selectedStore = {
        id: this.getAttribute("data-store-id"),
        name: this.getAttribute("data-store-name"),
        address: this.getAttribute("data-store-address"),
      };
      window.shopSettings.selectedStore = selectedStore; // Store globally
      const checkIcon = this.querySelector(".check-icon");
      console.log(checkIcon, "checkIcon");
      checkIcon.style.display = "block";

      // Update the sidebar with selected store
      const storeInfoElement = document.createElement("div");
      storeInfoElement.classList.add("selected-store-info");
      storeInfoElement.innerHTML = `
        <div class="store-name">${selectedStore.name}</div>
        <div class="store-address">${selectedStore.address}</div>
      `;

      // Add to the sidebar
      if (document.querySelector(".selected-store-info")) {
        document.querySelector(".selected-store-info").remove();
      }
      selectedRepairMethod.appendChild(storeInfoElement);

      // Enable the continue button
      //   continueBtn.classList.add("active");
      //   continueBtn.disabled = false;

      // Show the next step (in a real implementation)
      // document.querySelector('.visit-step:nth-child(2)').classList.add('active');
    });
  });

  // Postal code search
  const searchStoresBtn = document.getElementById("search-stores-btn");
  if (searchStoresBtn) {
    searchStoresBtn.addEventListener("click", function () {
      const postalCode = document.getElementById("postal-code").value;
      if (postalCode) {
        // In a real implementation, you would make an API call to find stores
        // alert(`Searching for stores near ${postalCode}`);
        // In a real implementation, you would update the map and store list
      }
    });
  }

  continueBtn.addEventListener("click", async function () {
    if (currentStep === 1 && Object.keys(selectedRepairs).length > 0) {
      goToStep(2);
      // Scroll to the service option title
      const serviceTitle = document.querySelector("#service-option-title");
      if (serviceTitle) {
        serviceTitle.scrollIntoView({
          behavior: "smooth",
          block: "start",
          offsetTop: 20,
        });
        console.log(serviceTitle, "serviceTitle");
      }
    } else if (currentStep === 2) {
      if (selectedMethod === "Visit Us" && selectedStore) {
        goToStep(3);
      } else if (selectedMethod && selectedMethod !== "Visit Us") {
        goToStep(3);
      }
    } else if (currentStep === 3) {
      console.log("Final step reached", window.shopSettings);
      calendarID = window.shopSettings.calendarId || null;
      selectedRepairs = window.shopSettings.selectedRepairs || {};
      selectedMethod = window.shopSettings.selectedMethod || null;
      mailInProduct = window.shopSettings.mailInProduct;
      selectedDateTime = window.shopSettings.selectedDateTime || null;
      console.log(selectedMethod, "selectedMethod");
      const itemsToAdd = [];
      try {
        const eventCreateResponse = await fetch(
          `${window.shopSettings.calendarApiServerUrl}/api/events?calendarID=${calendarID}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              summary: `Repair Method - ${selectedMethod}`,
              description: `Repair option: ${selectedMethod}, Repairs: ${
                Object.keys(selectedRepairs).length
              }`,
              start: selectedDateTime.start,
              end: selectedDateTime.end,
            }),
          }
        );

        if (eventCreateResponse.ok) {
          console.log("Event created successfully!");
        } else {
          alert("Failed to create event.");
          console.error("Failed to book appointment:", eventCreateResponse);
        }
      } catch (error) {
        console.error("Error creating event:", error);
        alert(
          "Failed to book appointment, please select a different date and time."
        );
      }
      // Add selected repairs
      for (const typeId in selectedRepairs) {
        const repair = selectedRepairs[typeId];
        itemsToAdd.push({
          id: repair.variantId,
          quantity: 1,
          properties: {
            "Repair Type": repair.type,
            "Repair Time": repair.repairTime,
            Warranty: repair.warranty,
            "Repair Name": repair.typeName,
            "Repair Method": selectedMethod || "",
            ...(selectedStore
              ? {
                  "Store Name": selectedStore.name,
                  "Store Address": selectedStore.address,
                }
              : {}),
          },
        });
      }

      // If Mail In, add the mailInProduct to cart as well
      if (
        selectedMethod === "Mail In" &&
        mailInProduct &&
        mailInProduct.variants &&
        mailInProduct.variants.length > 0
      ) {
        itemsToAdd.push({
          id: mailInProduct.variants[0].id,
          quantity: 1,
          properties: {
            "Repair Method": "Mail In",
          },
        });
      }

      if (itemsToAdd.length > 0) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToAdd }),
        })
          .then((res) =>
            res.json().then((data) => ({ status: res.status, data }))
          )
          .then(({ status, data }) => {
            if (status === 200 && !data.status) {
              // Success, redirect to cart
              console.log("✅ Added custom repairs to cart:", data);
              window.location.href = "/cart";
            } else {
              // Error, show alert with message
              let message =
                data.description ||
                data.message ||
                "Failed to add to cart. Please try again.";
              alert(message);
            }
          })
          .catch((err) => {
            console.error("❌ Cart error:", err);
            alert("Failed to add to cart. Please try again.");
          });
      }
    }
  });
  mobContBtn.addEventListener("click", async function () {
    if (currentStep === 1 && Object.keys(selectedRepairs).length > 0) {
      goToStep(2);
      // Scroll to the service option title
      const serviceTitle = document.querySelector("#service-option-title");
      if (serviceTitle) {
        serviceTitle.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else if (currentStep === 2) {
      if (selectedMethod === "Visit Us" && selectedStore) {
        goToStep(3);
      } else if (selectedMethod && selectedMethod !== "Visit Us") {
        goToStep(3);
      }
    } else if (currentStep === 3) {
      // --- COPY FROM DESKTOP CONTINUE BUTTON ---
      calendarID = window.shopSettings.calendarId || null;
      selectedRepairs = window.shopSettings.selectedRepairs || {};
      selectedMethod = window.shopSettings.selectedMethod || null;
      mailInProduct = window.shopSettings.mailInProduct;
      selectedDateTime = window.shopSettings.selectedDateTime || null;
      const itemsToAdd = [];
      try {
        const eventCreateResponse = await fetch(
          `${window.shopSettings.calendarApiServerUrl}/api/events?calendarID=${calendarID}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              summary: `Repair Method - ${selectedMethod}`,
              description: `Repair option: ${selectedMethod}, Repairs: ${
                Object.keys(selectedRepairs).length
              }`,
              start: selectedDateTime.start,
              end: selectedDateTime.end,
            }),
          }
        );

        if (eventCreateResponse.ok) {
          console.log("Event created successfully!");
        } else {
          alert("Failed to create event.");
          console.error("Failed to book appointment:", eventCreateResponse);
          return;
        }
      } catch (error) {
        console.error("Error creating event:", error);
        alert(
          "Failed to book appointment, please select a different date and time."
        );
        return;
      }
      // Add selected repairs
      for (const typeId in selectedRepairs) {
        const repair = selectedRepairs[typeId];
        itemsToAdd.push({
          id: repair.variantId,
          quantity: 1,
          properties: {
            "Repair Type": repair.type,
            "Repair Time": repair.repairTime,
            Warranty: repair.warranty,
            "Repair Name": repair.typeName,
            "Repair Method": selectedMethod || "",
            ...(selectedStore
              ? {
                  "Store Name": selectedStore.name,
                  "Store Address": selectedStore.address,
                }
              : {}),
          },
        });
      }

      // If Mail In, add the mailInProduct to cart as well
      if (
        selectedMethod === "Mail In" &&
        mailInProduct &&
        mailInProduct.variants &&
        mailInProduct.variants.length > 0
      ) {
        itemsToAdd.push({
          id: mailInProduct.variants[0].id,
          quantity: 1,
          properties: {
            "Repair Method": "Mail In",
          },
        });
      }

      if (itemsToAdd.length > 0) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToAdd }),
        })
          .then((res) =>
            res.json().then((data) => ({ status: res.status, data }))
          )
          .then(({ status, data }) => {
            if (status === 200 && !data.status) {
              // Success, redirect to cart
              window.location.href = "/cart";
            } else {
              // Error, show alert with message
              let message =
                data.description ||
                data.message ||
                "Failed to add to cart. Please try again.";
              alert(message);
            }
          })
          .catch((err) => {
            alert("Failed to add to cart. Please try again.");
          });
      }
    }
  });

  // changeRepairBtn.addEventListener("click", function () {
  //   goToStep(1);
  // });
  backBtn.addEventListener("click", function (e) {
    // Prevent anchor default navigation
    e.preventDefault();

    if (currentStep === 1) {
      // Redirect to your desired page, e.g. brand page or home
      window.location.href = `${window.shopSettings.backButtonLink}`;
      return;
    }
    if (currentStep === 2) {
      serviceCards.forEach((card) => {
        card.classList.remove("selected");
        selectedMethod = null;
        methodSummary.style.display = "none";
      });
      selectedRepairMethod.textContent = "";
      document.getElementById("appointment-summary").style.display = "none";
      visitUsContent.style.display = "none";
      mailInContent.style.display = "none";
      bookVanContent.style.display = "none";
      goToStep(1);
    } else if (currentStep === 3) {
      visitUsContent.style.display = "none";
      mailInContent.style.display = "none";
      bookVanContent.style.display = "none";
      serviceCards.forEach((card) => {
        card.classList.remove("selected");
        card.style.display = "flex";
        selectedMethod = null;
        methodSummary.style.display = "none";
        selectedRepairMethod.textContent = "";
      });
      document.getElementById("appointment-summary").style.display = "none";
      goToStep(2);
    } else if (currentStep > 1) {
      goToStep(currentStep - 1);
    }
  });
  // serviceCards.forEach((card) => {
  //   card.addEventListener("click", function () {
  //     if(this.classList.contains("selected")) {
  //       if(currentStep === 3) {
  //       serviceCards.forEach((c) => c.classList.remove("selected"));
  //       document.getElementById("visit-us-content").style.display = "none";
  //       document.getElementById("mail-in-content").style.display = "none";
  //       document.getElementById("book-van-content").style.display = "none";
  //       }
  //       goToStep(2);

  //     }
  //     goToStep(3);
  //   });
  // });

  // Functions
  function updateUI() {
    // Update selected repairs in sidebar
    const issueCountElem = document.querySelector(".issue-count");
    // Mobile elements
    const mobileIssueCountElem = document.getElementById("mobile-issue-count");
    const selectedRepairsListMobile = document.getElementById(
      "selected-repairs-list-mobile"
    );
    const methodSummaryMobile = document.getElementById(
      "method-summary-mobile"
    );
    const selectedRepairMethodMobile = document.getElementById(
      "selected-service-option-mobile"
    );
    const appointmentSummaryMobile = document.getElementById(
      "appointment-summary-mobile"
    );
    const appointmentDatetimeMobile = document.getElementById(
      "appointment-datetime-mobile"
    );

    if (Object.keys(selectedRepairs).length > 0) {
      let repairsHTML = "";
      let totalPrice = 0;
      if (issueCountElem) {
        issueCountElem.textContent = Object.keys(selectedRepairs).length;
        issueCountElem.style.display = "inline-flex";
      }
      for (const typeId in selectedRepairs) {
        const repair = selectedRepairs[typeId];
        const price = parseFloat(repair.price);
        totalPrice += price;

        repairsHTML += `
                    <div class="repair-item-section">
                    <div class="repair-item">
                        <div class="repair-item-details">
                            <div class="repair-item-name">${
                              repair.typeName
                            }</div>
                            <div class="repair-item-type">${repair.type}</div>
                        </div>
                        <div class="repair-item-price">£${price.toFixed(
                          2
                        )}</div>
                        </div>
                          <img  class="delete-icon" src="${deleteIconUrl}" alt="Delete" onclick="removeRepair('${typeId}')" />
                    </div>
                `;
      }

      // Add total price
      repairsHTML += `
                <div class="repair-item" style="margin-top: 10px; font-weight: bold;">
                    <div class="repair-item-name">Total</div>
                    <div class="repair-item-price">£${totalPrice.toFixed(
                      2
                    )}</div>
                </div>
            `;

      selectedRepairsList.innerHTML = repairsHTML;

      if (currentStep === 1) {
        continueBtn.classList.add("active");
        continueBtn.disabled = false;
        mobContBtn.classList.add("active");
        mobContBtn.disabled = false;
      }
    } else {
      if (issueCountElem) {
        issueCountElem.style.display = "none";
      }
      selectedRepairsList.innerHTML = "<p>No repairs selected</p>";
      continueBtn.classList.remove("active");
      continueBtn.disabled = true;
      mobContBtn.classList.remove("active");
      mobContBtn.disabled = true;
    }

    // Update selected repair method in sidebar
    if (selectedMethod) {
      methodSummary.style.display = "block";
      selectedRepairMethod.textContent = selectedMethod;

      if (currentStep === 2) {
        // continueBtn.classList.add("active");
        // continueBtn.disabled = false;
      }
    } else {
      if (currentStep === 2) {
        // methodSummary.style.display = "block";
        // selectedRepairMethod.textContent = "";
        continueBtn.classList.remove("active");
        continueBtn.disabled = true;
        mobContBtn.classList.remove("active");
        mobContBtn.disabled = true;
      } else {
        // methodSummary.style.display = "none";
      }
    }
    // If Visit Us is selected and a store is selected
    if (selectedMethod === "Visit Us" && selectedStore) {
      methodSummary.style.display = "block";

      // Enable continue button
      if (currentStep === 2) {
        // continueBtn.classList.add("active");
        // continueBtn.disabled = false;
      }
    }

    // --- MOBILE LOGIC ---
    if (Object.keys(selectedRepairs).length > 0) {
      let repairsHTML = "";
      let totalPrice = 0;
      if (mobileIssueCountElem) {
        mobileIssueCountElem.textContent = Object.keys(selectedRepairs).length;
        mobileIssueCountElem.style.display = "inline-flex";
      }
      for (const typeId in selectedRepairs) {
        const repair = selectedRepairs[typeId];
        const price = parseFloat(repair.price);
        totalPrice += price;

        repairsHTML += `
        <div class="repair-item-section">
          <div class="repair-item">
            <div class="repair-item-details">
              <div class="repair-item-name">${repair.typeName}</div>
              <div class="repair-item-type">${repair.type}</div>
            </div>
            <div class="repair-item-price">£${price.toFixed(2)}</div>
          </div>
          <img class="delete-icon" src="${deleteIconUrl}" alt="Delete" onclick="removeRepair('${typeId}')" />
        </div>
      `;
      }
      repairsHTML += `
      <div class="repair-item" style="margin-top: 10px; font-weight: bold;">
        <div class="repair-item-name">Total</div>
        <div class="repair-item-price">£${totalPrice.toFixed(2)}</div>
      </div>
    `;
      if (selectedRepairsListMobile)
        selectedRepairsListMobile.innerHTML = repairsHTML;
    } else {
      if (mobileIssueCountElem) mobileIssueCountElem.style.display = "none";
      if (selectedRepairsListMobile)
        selectedRepairsListMobile.innerHTML = "<p>No repairs selected</p>";
    }

    // Update selected repair method in mobile summary
    if (selectedMethod) {
      if (methodSummaryMobile) methodSummaryMobile.style.display = "block";
      if (selectedRepairMethodMobile)
        selectedRepairMethodMobile.textContent = selectedMethod;
    } else {
      if (methodSummaryMobile) methodSummaryMobile.style.display = "none";
      if (selectedRepairMethodMobile)
        selectedRepairMethodMobile.textContent = "";
    }

    // Update appointment info in mobile summary (if you have this logic)
    // Example:
    // if (appointmentSummaryMobile) appointmentSummaryMobile.style.display = ...;
    // if (appointmentDatetimeMobile) appointmentDatetimeMobile.textContent = ...;
  }

  function goToStep(stepNumber) {
    // Update current step
    currentStep = stepNumber;

    // Update step indicators
    steps.forEach((step) => {
      const stepNum = parseInt(step.getAttribute("data-step"));
      if (stepNum === currentStep) {
        step.classList.add("active");
      } else if (stepNum < currentStep) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });
    console.log(currentStep, "currentStep");

    if (currentStep === 3) {
      // document.getElementById(`step${currentStep}`).classList.add("active");
    } else {
      // Show current step content
      stepContents.forEach((content) => {
        content.classList.remove("active");
      });
      document.getElementById(`step${currentStep}`).classList.add("active");
    }
    console.log(stepNumber);
    // Update UI for the current step
    updateUI();
    // if (stepNumber === 3) {
    //   const itemsToAdd = [];

    //   for (const typeId in selectedRepairs) {
    //     const repair = selectedRepairs[typeId];

    //     itemsToAdd.push({
    //       id: repair.variantId,
    //       quantity: 1,
    //       properties: {
    //         "Repair Metaobject": repair.metaobjectHandle,
    //         "Repair Type": repair.type,
    //         "Repair Time": repair.repairTime,
    //         Warranty: repair.warranty,
    //         "Repair Method": selectedMethod,
    //       },
    //     });
    //   }

    //   if (itemsToAdd.length > 0) {
    //     fetch("/cart/add.js", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify({ items: itemsToAdd }),
    //     })
    //       .then((res) => res.json())
    //       .then((data) => {
    //         console.log("✅ Added custom repairs to cart:", data);
    //         // Now load the section after cart is updated
    //         return fetch(`${window.Shopify.routes.root}?sections=header`);
    //       })
    //       .then((res) => res.json())
    //       .then((sectionData) => {
    //         console.log(sectionData);
    //         //   Inject the new header HTML (adjust the selector to match your theme)
    //         const headerContainer = document.querySelector("header");
    //         if (headerContainer && sectionData.header) {
    //           console.log(headerContainer, "headerContainer");
    //           headerContainer.innerHTML = sectionData.header;
    //           // Reinitialize theme scripts
    //           window.dispatchEvent(new Event("scroll"));
    //         }
    //       })
    //       .catch((err) =>
    //         console.error("❌ Cart error or section load error:", err)
    //       );
    //   }
    // }
  }

  // Make functions available globally
  window.removeRepair = function (typeId) {
    // Remove the repair from the selected repairs
    delete selectedRepairs[typeId];

    // Remove selected class from the corresponding card
    document
      .querySelectorAll(`.option-card[data-repair-type-id="${typeId}"]`)
      .forEach((card) => {
        card.classList.remove("selected");
      });

    // Update UI
    updateUI();
  };

  window.clearAllRepairs = function () {
    // Clear all selected repairs
    selectedRepairs = {};

    // Remove selected class from all cards
    optionCards.forEach((card) => card.classList.remove("selected"));

    // Update UI
    updateUI();
  };

  function bindOptionCardEvents() {
    const optionCards = document.querySelectorAll(".option-card");
    optionCards.forEach((card) => {
      // Skip cards that are disabled (by attribute or by class)
      if (
        card.hasAttribute("disabled") ||
        card.classList.contains("disabled")
      ) {
        return;
      }
      card.addEventListener("click", function () {
        const repairTypeId = this.getAttribute("data-repair-type-id");

        // Remove selected class from all cards of the same repair type
        document
          .querySelectorAll(
            `.option-card[data-repair-type-id="${repairTypeId}"]`
          )
          .forEach((c) => {
            c.classList.remove("selected");
          });

        // Add selected class to clicked card
        this.classList.add("selected");

        // Store selected repair
        selectedRepairs[repairTypeId] = {
          variantId: this.getAttribute("data-variant-id"),
          type: this.getAttribute("data-repair-type"),
          price: this.getAttribute("data-price"),
          repairTime: this.getAttribute("data-repair-time"),
          warranty: this.getAttribute("data-warranty"),
          typeName: this.getAttribute("data-repair-type-name"),
        };
        // Store globally
        window.shopSettings.selectedRepairs = selectedRepairs;

        // Update UI
        updateUI();
      });
    });
  }

  // Initial bind
  document.addEventListener("DOMContentLoaded", bindOptionCardEvents);

  // Re-bind after AJAX navigation (Shopify themes with Turbo)
  document.addEventListener("shopify:section:load", bindOptionCardEvents);
  document.addEventListener("shopify:section:select", bindOptionCardEvents);
  // For themes using Turbo/InstantClick/Barba.js, use their page load event as well
});
